// @generated source--
// scripts/generate-bits/file-generators/component-routes.generator.ts

export const pipeRoutes = [
  {
    path: 'bypass-security-trust-resource-url',
    loadChildren: () =>
      import(
        './bypass-security-trust-resource-url/bypass-security-trust-resource-url-stories.module'
      ).then(m => m.BypassSecurityTrustResourceUrlStoriesModule),
  },
  {
    path: 'compact-number',
    loadChildren: () =>
      import('./compact-number/compact-number-stories.module').then(
        m => m.CompactNumberStoriesModule,
      ),
  },
  {
    path: 'freelancer-currency',
    loadChildren: () =>
      import('./freelancer-currency/freelancer-currency-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'date-range',
    loadChildren: () =>
      import('./date-range/date-range-stories.module').then(
        m => m.DateRangeStoriesModule,
      ),
  },
  {
    path: 'duration',
    loadChildren: () =>
      import('./duration/duration-stories.module').then(
        m => m.DurationStoriesModule,
      ),
  },
  {
    path: 'dynamic-time',
    loadChildren: () =>
      import('./dynamic-time/dynamic-time-stories.module').then(
        m => m.DynamicTimeStoriesModule,
      ),
  },
  {
    path: 'emoji',
    loadChildren: () =>
      import('./emoji/emoji-stories.routing').then(m => m.storyRoutes),
  },
  {
    path: 'file-size',
    loadChildren: () =>
      import('./file-size/file-size-stories.module').then(
        m => m.FileSizeStoriesModule,
      ),
  },
  {
    path: 'is-online',
    loadChildren: () =>
      import('./is-online/is-online-stories.module').then(
        m => m.IsOnlineStoriesModule,
      ),
  },
  {
    path: 'location',
    loadChildren: () =>
      import('./location/location-stories.module').then(
        m => m.LocationStoriesModule,
      ),
  },
  {
    path: 'pascal-case',
    loadChildren: () =>
      import('./pascal-case/pascal-case-stories.module').then(
        m => m.PascalCaseStoriesModule,
      ),
  },
  {
    path: 'sanitise',
    loadChildren: () =>
      import('./sanitise/sanitise-stories.module').then(
        m => m.SanitiseStoriesModule,
      ),
  },
  {
    path: 'truncate-filename',
    loadChildren: () =>
      import('./truncate-filename/truncate-filename-stories.module').then(
        m => m.TruncateFilenameStoriesModule,
      ),
  },
];
